import { getLocale } from "../runtime";

const sv_freeshipping = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fri frakt`
};

const freeshipping = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_freeshipping(inputs)
	return "freeShipping";
};

export { freeshipping as "freeShipping" };